import { atom } from "jotai";

const pageAtom = atom(0);
pageAtom.debugLabel = "Page";

const openAtom = atom({
    toolsExperience: false,
    projectType: false,
    productType: false,
    offeredGratification: false,
    forGratification: false,
    softSkills: false,
    requiredAreaOfExpertise: false,
    projectDeadline: false,
    hardSkills: false,
    offeredWorkingType: false,
    usedLanguages: false,
    bizOrTech: false,
    requiredAvailability: false,
    locations: false,
    teammateNickname: false,
    description: false
});
openAtom.debugLabel="Add Teammate Open Filters";

export { pageAtom,openAtom };
